export default __webpack_public_path__ + "static/media/twitter.934e2d4d.png";